import { useEffect } from 'react';

import { useBatchExpansion } from './BatchExpansionContext';
import { usePricingBatchStaging } from './PricingBatchStagingContext';

export function PricingBatchesQuickActionExpansionSync() {
    const { expandedRecordIds } = useBatchExpansion();
    const { setHasOpenQuickActionExpansion } = usePricingBatchStaging();

    useEffect(() => {
        setHasOpenQuickActionExpansion(expandedRecordIds.length > 0);
    }, [expandedRecordIds, setHasOpenQuickActionExpansion]);

    useEffect(() => {
        return () => {
            setHasOpenQuickActionExpansion(false);
        };
    }, [setHasOpenQuickActionExpansion]);

    return null;
}
